import type { DealInformationTab } from './types';

export const DEAL_INFORMATION_TABS: Array<{ label: string; value: DealInformationTab }> = [
  { label: 'Details', value: 'details' },
  { label: 'Deal Options', value: 'deal-options' },
  { label: 'Inclusions', value: 'inclusions' },
  { label: 'EGS', value: 'egs' },
  { label: 'Surcharges', value: 'surcharges' },
  { label: 'Blackout Dates', value: 'blackout-dates' },
  { label: 'Bundled Experiences', value: 'bundled-experiences' },
  { label: 'Campaign Schedules', value: 'campaign-schedules' },
];

export function getDealInformationTab(tab: string | null | undefined): DealInformationTab {
  return DEAL_INFORMATION_TABS.some((dealInformationTab) => dealInformationTab.value === tab)
    ? (tab as DealInformationTab)
    : 'details';
}
